var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3333 5.66671C16.3333 8.61337 13.9466 11 10.9999 11C8.05325 11 5.66659 8.61337 5.66659 5.66671C5.66659 2.72004 8.05325 0.333374 10.9999 0.333374C13.9466 0.333374 16.3333 2.72004 16.3333 5.66671ZM0.333252 17.6667C0.333252 14.12 7.43992 12.3334 10.9999 12.3334C14.5599 12.3334 21.6666 14.12 21.6666 17.6667V21.6667H0.333252V17.6667Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/account.dfaa880cdc3d9576ee4e3a85bcf4c157.svg";